export default {
  data() {
    return {
      _idleInterval: null,
      _sessionInterval: null
    };
  },
  mounted() {
    this._createSessionIntervals();
  },
  beforeDestroy() {
    this._clearSessionIntervals();
  },
  methods: {
    _createSessionIntervals() {
      this._clearSessionIntervals();
      this._idleInterval = this.$auth.session.startIdleCheck();
      this._sessionInterval = this.$auth.session.startChecking();
    },
    _clearSessionIntervals() {
      clearInterval(this._idleInterval);
      clearInterval(this._sessionInterval);
    }
  }
};